import type { ReactNode } from 'react';
import { cn } from './cn';

export type BadgeTone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger';

const TONES: Record<BadgeTone, string> = {
  neutral: 'bg-surface-2 text-fg-muted ring-1 ring-border',
  accent: 'bg-accent-soft text-accent-text',
  success: 'bg-surface-2 text-success ring-1 ring-border',
  warning: 'bg-surface-2 text-warning ring-1 ring-border',
  danger: 'bg-surface-2 text-danger ring-1 ring-border',
};

export function Badge({ tone = 'neutral', className, children }: { tone?: BadgeTone; className?: string; children: ReactNode }) {
  return <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 font-sans text-[11px] font-medium leading-4', TONES[tone], className)}>{children}</span>;
}
